<template>
    <topo>
        <template #ajuda>
            <ajuda/>
        </template>
        <template #configuracoes>
            <configuracoes/>
        </template>
    </topo>
</template>
<script>
import Topo from '@/shared/layouts/adminlte/components/Topo'
import Ajuda from './Ajuda'
import Configuracoes from './Configuracoes'
export default {
    components: {
        Topo, Ajuda, Configuracoes
    }
}
</script>